import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ApiResponse } from '@shared/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class UploadHttpService {
  static uploadedFile: any = null;
  static uploadedFileForm: any = null;
  constructor(private http: HttpClient) { }

  upload(data: any): Observable<[]> {
    return this.http.post<ApiResponse>('/file', data).pipe(
      map(res => res.data.files)
    );
  }
}
